module.exports = __webpack_public_path__ + "media/images/home/en/preview-1-86ccfeee3ed1fe8c7642453b97afd7ba.jpg";